const map = {
	"./en/translation.json": [
		"../assets/i18n/en/translation.json",
		[
			"assets_i18n_en_translation_json"
		]
	],
	"./nl/translation.json": [
		"../assets/i18n/nl/translation.json",
		[
			"assets_i18n_nl_translation_json"
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "../assets/i18n lazy recursive ^\\.\\/.*\\/.*\\.json$";
module.exports = webpackAsyncContext;